import type { TechColumnName, TechColumnType } from "../types/columns";

export const createTechColumnName = (columnType: TechColumnType, technologyOrCategoryName?: string): TechColumnName => {
    return `${columnType}:${technologyOrCategoryName}`;
};
